import { ControlSection } from '@bloomfieldrobotics/canopy';
import { useRanchesByCustomer } from '../../../services/entities/hooks/useRanchesByCustomer';
import { Block } from '../../../services/entities/impl/blfApi/schemas/block';
import { useTranslation } from '../../../services/translation/hooks/useTranslation';
import { BlockMultiSelectItem } from './BlockMultiSelectItem';

type Props = {
  customerId: string;
  blocksByRanch: Map<string, Block[]>;
  blocksSelected: Map<string, string[]>;
  onChange: (ranchId: string, blockIds: string[]) => void;
};

export const LocationControlSection = ({
  customerId,
  blocksByRanch,
  blocksSelected,
  onChange,
}: Props) => {
  const { t } = useTranslation();

  // get all blocks and ranches for the customer
  const { ranches, isRanchesLoading } = useRanchesByCustomer(customerId);

  return (
    <ControlSection title={t('Location')} loading={isRanchesLoading}>
      {ranches?.map((ranch) => (
        <BlockMultiSelectItem
          key={ranch.id}
          ranchName={ranch.name}
          blocks={blocksByRanch.get(ranch.id) || []}
          blocksSelected={blocksSelected.get(ranch.id) || []}
          onChange={(blockIds) => onChange(ranch.id, blockIds)}
        />
      ))}
    </ControlSection>
  );
};
